const Layout = () => import('@/layout/index.vue')

export default {
    path: '/auth',
    component: Layout,
    redirect: '/auth/menu',
    name: 'Auth',
    meta: {
        title: '权限管理',
        icon: 'auth'
    },
    children: [
        {
            path: 'menu',
            name: 'AuthMenu',
            component: () => import('@/views/auth/menu/index.vue'),
            meta: {
                title: '菜单管理',
                icon: 'auth-menu',
                auth: ['auth.menu']
            }
        },
        {
            path: 'info',
            name: 'AuthInfo',
            component: () => import('@/views/auth/info/index.vue'),
            meta: {
                title: '权限信息',
                icon: 'auth-info',
                auth: ['auth.info']
            }
        },
        {
            path: 'role',
            name: 'AuthRole',
            component: () => import('@/views/auth/role/index.vue'),
            meta: {
                title: '角色管理',
                icon: 'auth-role',
                auth: ['auth.role']
            }
        },
        {
            path: 'user',
            name: 'AuthUser',
            component: () => import('@/views/auth/user/index.vue'),
            meta: {
                title: '用户管理',
                icon: 'auth-user',
                auth: ['auth.user']
            }
        }
    ]
}
